import {
  SET_BEHAVIORS,
} from '../actions/types';

export default (state = [], action) => {
  switch (action.type) {
    case SET_BEHAVIORS:
      return [ ...action.payload ];
    default:
      return state;
  }
};
